import images from '@assets/images/index'
import { GetAPIparams } from '@utils/assessmentReportUtils'
import { Flex } from 'antd'

import { Link } from '@suntex.core/nav'
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react'
import { $EntityLevel, EntityLevel } from '@suntex.fim/enums'
import { getFlags } from '@suntex.fim/flags'

type FactFluencyProps = {
  type: 'purple' | 'green' | 'red' | 'blue'
}
const factFluencyImages = {
  purple: images.WedgeFactFluencyPurple,
  red: images.WedgeFactFluencyRed,
  green: images.WedgeFactFluencyGreen,
  blue: images.WedgeFactFluencyBlue
}
/**
 * returns JSX for fact fluency
 */
function FactFluency({ type }: FactFluencyProps) {
  const { login } = useAuth(isAuthenticated)
  const { id, level } = GetAPIparams(login.entityLevel === EntityLevel.School)
  if (!getFlags().player.goals) return null

  return (
    <Flex gap="10px" className={'graph-tiles print-hidden'}>
      <div className="fluency-widget">
        <Link
          className="report-link"
          to={`/${$EntityLevel.describe(level).slug}/${id}/assessment-report/goals-index`}
        >
          <img
            src={factFluencyImages[type]}
            alt="Wedge Fact Fluency icon"
            width={100}
          />
        </Link>
      </div>
      <div>
        This assessment is one of the four components of the First In Math®
        Goals Index. Click the image or{' '}
        <Link
          to={`/${$EntityLevel.describe(level).slug}/${id}/assessment-report/goals-index`}
        >
          here
        </Link>{' '}
        to view the goals for the current team
      </div>
    </Flex>
  )
}

export default FactFluency
